import React, { createContext, useContext, useEffect, useReducer, } from "react";
import { useOfferFiltersSync } from "./useOfferFiltersSync";
import { initialState, offerFiltersReducer } from "./OfferFiltersReducer";
// Separate contexts for state and dispatch.
// Components subscribing to only one won't re-render when the other changes.
const OfferFiltersStateContext = createContext(null);
const OfferFiltersDispatchContext = createContext(null);
export function OfferFiltersProvider({ children, lockedFinanceType = null, hiddenFilters = {}, }) {
    const [state, dispatch] = useReducer(offerFiltersReducer, Object.assign(Object.assign({}, initialState), { lockedFinanceType, hiddenFilters }));
    useEffect(() => {
        dispatch({ type: "initialize_request" });
    }, [dispatch]);
    useEffect(() => {
        const handleOpen = () => dispatch({ type: "open_overlay" });
        window.addEventListener("offerFilters:open", handleOpen);
        return () => window.removeEventListener("offerFilters:open", handleOpen);
    }, [dispatch]);
    useOfferFiltersSync(state, dispatch);
    return (<OfferFiltersStateContext.Provider value={state}>
      <OfferFiltersDispatchContext.Provider value={dispatch}>
        {children}
      </OfferFiltersDispatchContext.Provider>
    </OfferFiltersStateContext.Provider>);
}
export function useOfferFiltersState() {
    const ctx = useContext(OfferFiltersStateContext);
    if (!ctx) {
        throw new Error("useOfferFiltersState must be used within OfferFiltersProvider");
    }
    return ctx;
}
export function useOfferFiltersDispatch() {
    const ctx = useContext(OfferFiltersDispatchContext);
    if (!ctx) {
        throw new Error("useOfferFiltersDispatch must be used within OfferFiltersProvider");
    }
    return ctx;
}
